import { isOver } from '../../shiftUtils';
import { DateTime } from 'luxon';
export var shiftHasDropPenalty = function (scheduleShift, dropOpportunity) {
    var dropWithoutPenaltyDeadline = !!(dropOpportunity === null || dropOpportunity === void 0 ? void 0 : dropOpportunity.penaltyStartTime)
        ? DateTime.fromISO(dropOpportunity.penaltyStartTime)
        : null;
    if (!dropWithoutPenaltyDeadline) {
        return false;
    }
    if (isOver(scheduleShift.shift)) {
        return false;
    }
    return dropWithoutPenaltyDeadline <= DateTime.now();
};
